import React, { useEffect, useState, useCallback } from 'react';
import TextFieldCS from '../../../common/ComponentesCS/TextFieldCS';
import Button from '@material-ui/core/Button';
// import APP from '../../common/tools/AppRoutes';

const Filters = ({ onFiltersChange, onClearFilters }) => {
    // Estado para manejar múltiples campos de texto
    const [filters, setFilters] = useState({
        clienteId: '',
        nombreCliente: '',
        estatus: ''
    });

    // Efecto para notificar cambios de filtros automáticamente
    useEffect(() => {
        // Solo notificar si hay algún filtro activo para evitar llamadas innecesarias
        const hasActiveFilters = Object.values(filters).some(value => value.trim() !== '');

        if (hasActiveFilters && onFiltersChange) {
            onFiltersChange(filters);
        } else if (!hasActiveFilters && onClearFilters) {
            // Si no hay filtros activos, limpiar
            onClearFilters();
        }
    }, [filters]); // Solo 'filters' en las dependencias

    // Función para manejar cambios en cualquier TextField
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFilters(prevFilters => ({
            ...prevFilters,
            [name]: value
        }));
    };

    // Función para limpiar todos los filtros
    const clearFilters = useCallback(() => {
        const emptyFilters = {
            clienteId: '',
            nombreCliente: '',
            estatus: ''
        };
        setFilters(emptyFilters);

        // Notificar al componente padre
        if (onClearFilters) {
            onClearFilters();
        }
    }, [onClearFilters]);

    return (
        <div style={{ display: 'flex', flexDirection: 'row', padding: '10px', gap: '15px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', flexWrap: 'wrap', width: '80%' }}>
                <TextFieldCS
                    id="clienteId"
                    name="clienteId"
                    label="ID Cliente"
                    value={filters.clienteId}
                    onChange={handleInputChange}

                    style={{ minWidth: '200px' }}
                />

                <TextFieldCS
                    id="nombreCliente"
                    name="nombreCliente"
                    label="Nombre Cliente"
                    value={filters.nombreCliente}
                    onChange={handleInputChange}

                    style={{ minWidth: '200px' }}
                />

                <TextFieldCS
                    id="estatus"
                    name="estatus"
                    label="Estatus"
                    value={filters.estatus}
                    onChange={handleInputChange}

                    style={{ minWidth: '200px' }}
                />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px', width: '20%' }}>
                {/* <Button
                    onClick={clearFilters}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#f44336',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        height: '40px'
                    }}

                >
                    Limpiar Filtros
                </Button> */}
                <Button className="botonAmarillo floatLeft" onClick={clearFilters} variant="contained">Limpiar Filtros</Button>

            </div>
        </div>
    );
};

export default Filters;
